import { inject as t } from "vue";
import { OptionalInjectionFacade as e } from "./optional-injection-facade.js";
import { MissingInjectionError as o } from "./errors/missing-injection-error.js";
class d extends e {
  injectionDescription;
  constructor(i, n) {
    super(i), this.injectionDescription = n ?? i.description ?? `injection facade named ${this.constructor.name}`;
  }
  useInjection() {
    const i = t(this.key, void 0);
    if (i === void 0)
      throw new o(this.injectionDescription);
    return i;
  }
}
export {
  d as RequiredInjectionFacade
};
//# sourceMappingURL=required-injection-facade.js.map
